<template>
  <v-main>
    <div class="option-item">
      <!-- Change is_student to is_faculty and vice versa -->
      <div v-if="currentUser.is_faculty">
        <div v-for="option in question.options" :key="option.id">
          <p class="op">
            <span>
              <i class="far fa-circle"></i>
            </span>
            {{ option.op }}
            <span>
              <i v-if="option.is_correct" class="fas fa-check"></i>
            </span>
          </p>
          <div class="text-center">
            <img v-if="option.image" :src="option.image" class="option-image" />
          </div>
        </div>
      </div>
      <div v-if="currentUser.is_student">
        <v-radio-group
          @change="selectAnswer"
          v-model="selectedOption"
          v-for="option in question.options"
          :key="option.id"
        >
          <v-radio :label="option.op" :value="option.id"></v-radio>
          <div class="text-center">
            <img v-if="option.image" :src="option.image" class="option-image" />
          </div>
        </v-radio-group>
      </div>
    </div>
  </v-main>
</template>

<script>
import { mapGetters, mapActions } from "vuex";

export default {
  name: "OptionList",
  props: ["question"],
  data() {
    return {
      selectedOption: null
    };
  },
  methods: {
    ...mapActions(["addAnswer"]),
    // add selectedAnswer to answers
    selectAnswer(answerId) {
      this.addAnswer({
        question: this.question.id,
        answer: answerId
      });
    }
  },
  computed: {
    ...mapGetters(["currentUser", "answers"]),
  },
  created() {
    // get answer if previously selected (stored in state)
    this.selectedOption = this.answers[this.question.id];
  }
};
</script>

<style>
.v-label {
  left: 15px !important;
}
</style>

<style scoped>
.op {
  margin-bottom: 15px;
}
.fa-circle {
  font-size: 14px;
  padding-right: 20px;
}
.fa-check {
  padding-left: 14px;
}
.option-image {
  width: 300px;
}
</style>

